import Controller from "@sabyr-dev/mist_core/controller";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyApp } from "../app";
import { CheckEmailEvent, PromptEmailEvent, SaveEmailEvent, ResendEmailEvent} from "../events";

export class EmailController extends Controller<Product, Attempt, Quiz, Question> {
	review: boolean = false;

	constructor(review: boolean) {
		super();
		this.review = review;
	}

	bind(target: EventTarget, app: AcademyApp): void {
		target.addEventListener(PromptEmailEvent.type, () => this.promptEmail(app));
		target.addEventListener(SaveEmailEvent.type, (e: SaveEmailEvent) => this.saveEmail(app, e));
		target.addEventListener(ResendEmailEvent.type, (e: ResendEmailEvent) => this.resendEmail(app, e));
		target.addEventListener(CheckEmailEvent.type, (e: CheckEmailEvent) => this.checkEmail(app, e));
	}

	async promptEmail(app: AcademyApp): Promise<void> {
		const list = await app.model.list.getItemList();
		const unlockCount = list.length - app.config.freeQuestions;
		app.view.settings.displayEmailModal(app.getJquery(), unlockCount);
	}

	async saveEmail(app: AcademyApp, event: SaveEmailEvent): Promise<boolean> {
		event.preventDefault();
		const [attempt, product] = await Promise.all([
			app.model.metadata.getAttempt(),
			app.model.metadata.getProductId()
		]);
		const email = event.detail.elements['email'].value;
		app.config.hasEmail = await app.model.settings.setEmail(product, email);
		if (app.config.hasEmail) {
			await this.unlock(app, product, attempt, email);
		} else {
			app.view.settings.hideEmailModal(app.getJquery());
			app.view.settings.displayDoubleOptInModal(app.getJquery(), email);
		}
		return false;
	}

	async resendEmail(app: AcademyApp, event: ResendEmailEvent): Promise<boolean> {
		await this.saveEmail(app, event);
		app.view.settings.displayDoubleOptInRetry();
		return false;
	}

	async checkEmail(app: AcademyApp, event: CheckEmailEvent): Promise<void> {
		event.preventDefault();
		const [attempt, product] = await Promise.all([
			await app.model.metadata.getAttempt(),
			await app.model.metadata.getProductId()
		]);
		const email = event.detail.elements['email'].value;
		app.config.hasEmail = await app.model.settings.checkEmail(product, email);
		if (app.config.hasEmail) {
			await this.unlock(app, product, attempt, email);
		} else {
			app.view.settings.displayDoubleOptInUnlock();
		}
	}

	async unlock(app: AcademyApp, product: Product, attempt: Attempt, email: string): Promise<void> {
		if (this.review) {
			await app.model.metadata.setIncomplete(product, attempt);
			const testUrl = await app.model.metadata.getTestUrl();
			app.view.item.displayTest(testUrl);
		} else {
			app.view.list.displayLockedQuestions(
				app.config.freeQuestions,
				!app.config.hasEmail,
				app.config.review ? 'rgb(23, 162, 184)' : `rgb(${app.config.color}, 0.5)`
			);
			app.view.settings.updateReportEmail(email);
			app.view.settings.hideEmailModal(app.getJquery());
			app.view.settings.hideDoubleOptInModal(app.getJquery());
		}
	}
}
